/* eslint-disable import/no-cycle */
/* eslint-disable camelcase */
import React from 'react';
import { Form, Icon, Table } from 'semantic-ui-react';
import * as _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import * as assetActions from '../redux/actions';
import { GEOFENCE } from '../../../HelperMethods/enums';
// import { GEOFENCE_OPTIONS } from './constants';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../HelperMethods/FormUtils';

const geoFencePolygonInitValue = {
  latitude: '',
  longitude: '',
};
let valueObj = {
  latitude: '',
  longitude: '',
};

const circularAreaInitial = {
  type: GEOFENCE.RADIAL,
  radius: '',
  polygon: [{ latitude: '', longitude: '' }],
};

const polygonAreaObjInitial = {
  type: GEOFENCE.POLYGON,
  radius: '',
  polygon: [
    { latitude: '', longitude: '' },
    { latitude: '', longitude: '' },
    { latitude: '', longitude: '' },
  ],
};

const GeofenceComponent = ({ attributeObj, formik }) => {
  const dispatch = useDispatch();
  const polygonAreaObj = _.cloneDeep(formik.values.geofence_geofenceDetails) || [];
  const polygonAreaState = formik?.values.geofence_geofenceDetails.type === 'polygon';
  const circleArea = formik?.values.geofence_geofenceDetails.type === 'radial';
  const Latitude = formik?.values.geo_latitude || '';
  const Longitude = formik?.values.geo_longitude || '';
  const Radius = formik?.values.geofence_geofenceDetails?.radius;
  const polygonAreaCoordinates = _.get(formik, 'values.geofence_geofenceDetails.polygon', []);
  const { polygonGeofence, radialGeofence } = useSelector((state) => state.assetReducer);

  React.useEffect(() => {
    if (_.isArray(polygonAreaCoordinates) && polygonAreaCoordinates.length >= 3) {
      polygonAreaCoordinates.push({ latitude: '', longitude: '' });
    }
  }, []);

  const onRadioButtonvalueChange = (event) => {
    const polygonAreaStatefromForm = formik?.values.geofence_geofenceDetails.type === 'polygon';
    const circleAreaState = formik?.values.geofence_geofenceDetails.type === 'radial';
    // const polygon = _.get(formik, 'values.geofence_geofenceDetails.polygon', []);
    // const radius = _.get(formik, 'values.geofence_geofenceDetails.radius', '');
    const geofence = _.get(formik, 'values.geofence_geofenceDetails', {});

    if (event.target.name === 'polygonArea') {
      dispatch(assetActions.assetGeofenceUpdate(geofence));

      if (polygonAreaStatefromForm) {
        const polygonAreaInitialvalue = { ...polygonAreaObjInitial, type: '' };
        formik.setFieldValue('geofence_geofenceDetails', polygonAreaInitialvalue);
      } else {
        formik.setFieldValue('geofence_geofenceDetails', polygonGeofence);
      }
    }
    if (event.target.name === 'circleArea') {
      dispatch(assetActions.assetGeofenceUpdate(geofence));

      if (circleAreaState) {
        const circleAreaInitialvalue = { ...circularAreaInitial, type: '' };

        formik.setFieldValue('geofence_geofenceDetails', circleAreaInitialvalue);
      } else {
        formik.setFieldValue('geofence_geofenceDetails', radialGeofence);
      }
    }
  };

  const onCircleAreaChange = (event) => {
    // const initialValue = _.cloneDeep(polygonAreaObj.coordinates || valueObj);

    const initialValue = [{ latitude: Latitude, longitude: Longitude }];

    if (event.target.placeholder === 'Latitude') {
      valueObj.latitude = event.target.value;
      valueObj.longitude = initialValue[0].longitude;
      formik.setFieldValue('geo_latitude', event.target.value);
    }
    if (event.target.placeholder === 'Longitude') {
      valueObj.longitude = event.target.value;
      valueObj.latitude = initialValue[0].latitude;
      formik.setFieldValue('geo_longitude', event.target.value);
    }
    if (event.target.placeholder === 'Radius') {
      polygonAreaObj.radius = event.target.value;
    }

    polygonAreaObj.polygon = _.cloneDeep(initialValue);
    polygonAreaObj.polygon[0] = valueObj;
    formik.setFieldValue('geofence_geofenceDetails', polygonAreaObj);
  };

  const handleDeleteRow = (index) => {
    const partsClone = _.cloneDeep(formik.values.geofence_geofenceDetails.polygon);
    const errorClone = _.cloneDeep(formik?.errors?.geofence_geofenceDetails?.polygon || []);

    if (errorClone) {
      errorClone.splice(index, 1);
      formik.setFieldError('geofence_geofenceDetails', errorClone);
    }

    partsClone.splice(index, 1);
    formik.setFieldValue('geofence_geofenceDetails.polygon', partsClone, false);

    if (index === 3) {
      const tempPolygonAreaList = _.cloneDeep(formik.values.geofence_geofenceDetails.polygon);
      tempPolygonAreaList[index] = geoFencePolygonInitValue;

      formik.setFieldValue('geofence_geofenceDetails.polygon', tempPolygonAreaList, false);
    }
  };
  const getIndex = (indexString) => {
    if (_.isString(indexString)) {
      try {
        const tempIndex = indexString.split('id_');

        return parseInt(tempIndex[1]);
      } catch (error) {
        console.error(error);
        return false;
      }
    }
    return false;
  };
  const onPolygonAreaChange = (event) => {
    if (event.target.id.includes('id_')) {
      const index = getIndex(event.target.id);

      const initialValue = _.cloneDeep(polygonAreaObj.polygon[index] || valueObj);

      if (_.isNumber(index)) {
        if (event.target.placeholder === 'Latitude') {
          valueObj.latitude = event.target.value;
          valueObj.longitude = initialValue.longitude;
        }
        if (event.target.placeholder === 'Longitude') {
          valueObj.longitude = event.target.value;
          valueObj.latitude = initialValue.latitude;
        }

        polygonAreaObj.polygon[index] = valueObj;
        valueObj = {
          latitude: '',
          longitude: '',
        };

        if (
          index + 1 === polygonAreaObj.polygon.length &&
          !_.isEmpty(polygonAreaObj.polygon[index].latitude) &&
          !_.isEmpty(polygonAreaObj.polygon[index].longitude)
        ) {
          polygonAreaObj.polygon.push(geoFencePolygonInitValue);
        }

        formik.setFieldValue('geofence_geofenceDetails', polygonAreaObj);
      }
    }
  };
  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '0rem 1rem' }}>
        <div style={{ width: '200px', display: 'flex', justifyContent: 'space-between', padding: '1rem 0rem' }}>
          <div>
            {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.CHECKBOX]({
              name: attributeObj.polygonArea,
              placeholder: 'Polygon Area',
              value: polygonAreaState,
              disabled: false,
              onChange: onRadioButtonvalueChange,
            })}
          </div>
          <div>
            {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.CHECKBOX]({
              name: attributeObj.circleArea,
              placeholder: 'Radial Area',
              value: circleArea,
              disabled: false,
              onChange: onRadioButtonvalueChange,
            })}
          </div>
        </div>
        <div>
          {polygonAreaState && (
            <div>
              <Table id="partsTable">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={2}>Latitude</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Logitude</Table.HeaderCell>
                    <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                {polygonAreaCoordinates.map(({ latitude, longitude }, index) => {
                  return (
                    <Table.Body key={index}>
                      <Table.Row>
                        <Table.Cell>
                          <Form.Field>
                            {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.DECIMAL]({
                              name: attributeObj.polygonArea,
                              placeholder: 'Latitude',
                              value: latitude,
                              disabled: false,
                              onChange: onPolygonAreaChange,
                              index: `${index}`,
                            })}
                          </Form.Field>
                        </Table.Cell>
                        <Table.Cell>
                          <Form.Field>
                            {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.DECIMAL]({
                              name: attributeObj.polygonArea,
                              placeholder: 'Longitude',
                              value: longitude,
                              disabled: false,
                              onChange: onPolygonAreaChange,
                              index: `${index}`,
                            })}
                          </Form.Field>
                        </Table.Cell>
                        <Table.Cell>
                          {index > 2 && <Icon name="trash alternate outline" onClick={() => handleDeleteRow(index)} />}
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  );
                })}
              </Table>
            </div>
          )}
          {circleArea && (
            <div>
              <Table id="partsTable">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={2}>Latitude</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Logitude</Table.HeaderCell>
                    <Table.HeaderCell width={2}>Radius (in Meters)</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell>
                      <Form.Field>
                        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.DECIMAL]({
                          name: attributeObj.LatitudeDisplayName,
                          placeholder: 'Latitude',
                          value: Latitude,
                          disabled: false,
                          onChange: onCircleAreaChange,
                        })}
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.DECIMAL]({
                          name: attributeObj.LongitudeDisplayName,
                          placeholder: 'Longitude',
                          value: Longitude,
                          disabled: false,
                          onChange: onCircleAreaChange,
                        })}
                      </Form.Field>
                    </Table.Cell>
                    <Table.Cell>
                      <Form.Field>
                        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.DECIMAL]({
                          name: attributeObj.RadiusDisplayName,
                          placeholder: 'Radius',
                          value: Radius,
                          disabled: false,
                          onChange: onCircleAreaChange,
                        })}
                      </Form.Field>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GeofenceComponent;
